import React, {useEffect, useState} from 'react';
import dayjs from "dayjs";
import Cookies from "js-cookie";
import {Button, Card, Form, Input, message, Modal} from "antd";
import {useNavigate} from "react-router-dom";
import copy from "copy-to-clipboard";

import { AiOutlineCopy } from "react-icons/ai"

const Admin_setting=()=>{


    document.title='设置'

    const navigate=useNavigate();


    let data_time=dayjs().unix();



    useEffect(() => {
        const usecookie = () => {




            switch (Cookies.get('userToken_chattool')) {

                case undefined:

                    navigate('/login?return_url=/admin/setting')


                    break;

                default:


                    setupdate_password_modal_onfinish_select_log({message:'',value:'',time:0})
                    window.scrollTo(0, 0); // 每次页面加载时将滚动条位置重置到顶部
                    break;


            }


        }

        usecookie();
    }, []); // 空数组表示仅在组件挂载时执行





    const [update_password_modal_open, setupdate_password_modal_open] = useState(false)

    const [update_password_select_info, setupdate_password_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [update_password_select_log, setupdate_password_select_log] = useState({message: '', value: '', time: 0})
    const update_password = (e1: any) => {

        setupdate_password_select_log({message: 'click', value: '', time: data_time})

        setupdate_password_modal_open(true);

        setupdate_password_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const setupdate_password_modal_oncancel = () => {

        setupdate_password_modal_open(false);
    }


    const [update_password_modal_form]=Form.useForm();

    const update_password_modal_initialValues={




    }

    const [update_password_modal_onfinish_select_log,setupdate_password_modal_onfinish_select_log]=useState({message:'',value:'',time:0})

    const [update_password_modal_onfinish_select_info,setupdate_password_modal_onfinish_select_info]=useState({value1:'',value2:'',value3:'',time:0});

    const update_password_modal_onfinish = (e1:any) => {

        let data_time=dayjs().unix();

        setupdate_password_modal_onfinish_select_log({message:'next_button',value:'',time:data_time})
        setupdate_password_modal_onfinish_select_info({value1:e1,value2:'',value3:'',time:data_time})
    }


    const [return_data_update_password,setreturn_data_update_password]=useState({});

    const update_password_body = new FormData();


    update_password_body.append('finish_data', JSON.stringify(update_password_modal_onfinish_select_info.value1));

    update_password_body.append('userToken', String(Cookies.get('userToken_chattool')));

    update_password_body.append('time', String(update_password_modal_onfinish_select_info.time));

    update_password_body.append('action', 'del_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/admin/beast_setting/update/update_password.php', {


                method: 'POST',
                body: update_password_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setupdate_password_modal_open(false)

                    setreturn_data_update_password(return_data);
                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/setting')


                    break


            }

        }


        if(update_password_modal_onfinish_select_log.message!==''){

            data_async();
            setupdate_password_modal_onfinish_select_log({message:'',value:'',time:0})
        }
    }, [update_password_modal_onfinish_select_log]);

    const [show_private_key_modal_open, setshow_private_key_modal_open] = useState(false)


    const setshow_private_key_modal_oncancel = () => {

        setshow_private_key_modal_open(false);
    }


    const [show_private_key_select_info, setshow_private_key_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [show_private_key_select_log, setshow_private_key_select_log] = useState({message: '', value: '', time: 0})
    const show_private_key = (e1: any) => {

        setshow_private_key_select_log({message: 'click', value: '', time: data_time})



        setshow_private_key_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const [return_data_show_private_key,setreturn_data_show_private_key]=useState({message:0,value:'',info:{private_key:''}});

    const show_private_key_body = new FormData();


    show_private_key_body.append('id', show_private_key_select_info.value1);

    show_private_key_body.append('userToken', String(Cookies.get('userToken_chattool')));

    show_private_key_body.append('time', String(show_private_key_select_info.time));

    show_private_key_body.append('action', 'fetch_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/admin/beast_setting/fetch/fetch_private_key.php', {


                method: 'POST',
                body: show_private_key_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setreturn_data_show_private_key(return_data);

                    //  setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})
                    setshow_private_key_modal_open(true)
                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/setting')


                    break


            }

        }


        if(show_private_key_select_log.message!==''){

            data_async();
            setshow_private_key_select_log({message:'',value:'',time:0})
        }
    }, [show_private_key_select_log]);





    const [update_private_key_modal_open, setupdate_private_key_modal_open] = useState(false)

    const [update_private_key_select_info, setupdate_private_key_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [update_private_key_select_log, setupdate_private_key_select_log] = useState({message: '', value: '', time: 0})
    const update_private_key = (e1: any) => {

        setupdate_private_key_select_log({message: 'click', value: '', time: data_time})

        setupdate_private_key_modal_open(true);

        setupdate_private_key_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const setupdate_private_key_modal_oncancel = () => {

        setupdate_private_key_modal_open(false);
    }


    const [update_private_key_modal_form]=Form.useForm();

    const update_private_key_modal_initialValues={




    }

    const [update_private_key_modal_onfinish_select_log,setupdate_private_key_modal_onfinish_select_log]=useState({message:'',value:'',time:0})

    const [update_private_key_modal_onfinish_select_info,setupdate_private_key_modal_onfinish_select_info]=useState({value1:'',value2:'',value3:'',time:0});

    const update_private_key_modal_onfinish = (e1:any) => {

        let data_time=dayjs().unix();

        setupdate_private_key_modal_onfinish_select_log({message:'next_button',value:'',time:data_time})
        setupdate_private_key_modal_onfinish_select_info({value1:e1,value2:'',value3:'',time:data_time})
    }


    const [return_data_update_private_key,setreturn_data_update_private_key]=useState({});

    const update_private_key_body = new FormData();


    update_private_key_body.append('finish_data', JSON.stringify(update_private_key_modal_onfinish_select_info.value1));

    update_private_key_body.append('userToken', String(Cookies.get('userToken_chattool')));

    update_private_key_body.append('time', String(update_private_key_modal_onfinish_select_info.time));

    update_private_key_body.append('action', 'del_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://chatv2.leytcn.com/api/admin/beast_setting/update/update_private_key.php', {


                method: 'POST',
                body: update_private_key_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setupdate_private_key_modal_open(false)

                    setreturn_data_update_private_key(return_data);
                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/setting')


                    break


            }

        }


        if(update_private_key_modal_onfinish_select_log.message!==''){

            data_async();
            setupdate_private_key_modal_onfinish_select_log({message:'',value:'',time:0})
        }
    }, [update_private_key_modal_onfinish_select_log]);



    const copy_text=(e1:any)=>{


        message.success('复制成功')

        copy(e1)


    }
    return(<div>




        <Card title={'修改密码'}>

            <Button onClick={update_password}>修改</Button>

        </Card>




      {/*  <Card title={'oos私有key'}>

            <Button onClick={update_private_key}>设置</Button>

            <Button style={{marginLeft:10}} onClick={show_private_key}>查看</Button>

        </Card>
*/}



        <Modal open={show_private_key_modal_open} onCancel={setshow_private_key_modal_oncancel} footer={null} title={'查看私有key'}>


            <label>key：{return_data_show_private_key.info.private_key}</label>

            <AiOutlineCopy  style={{marginLeft:10}} onClick={()=>copy_text(return_data_show_private_key.info.private_key)}>复制</AiOutlineCopy >

            <p></p>
            <Button style={{}} onClick={setshow_private_key_modal_oncancel}>

                取消
            </Button>


        </Modal>


        <Modal open={update_password_modal_open} onCancel={setupdate_password_modal_oncancel} footer={null} title={'设置密码'}>




            <Form form={update_password_modal_form} initialValues={update_password_modal_initialValues} onFinish={update_password_modal_onfinish}>

                <label>旧密码</label>

                <Form.Item name={'input_value1'} rules={[{message:'必填项',required:true}]}>

                    <Input>



                    </Input>


                </Form.Item>

                <label>新密码</label>

                <Form.Item name={'input_value2'} rules={[{message:'必填项',required:true}]}>

                    <Input>



                    </Input>


                </Form.Item>

                <label>再次输入新密码</label>

                <Form.Item name={'input_value3'} rules={[{message:'必填项',required:true}]}>

                    <Input>



                    </Input>


                </Form.Item>


                <Button htmlType={'submit'} type={'primary'}>提交</Button>
                <Button style={{marginLeft:10}} onClick={setupdate_password_modal_oncancel}>取消</Button>

            </Form>


        </Modal>







        <Modal open={update_private_key_modal_open} onCancel={setupdate_private_key_modal_oncancel} footer={null} title={'设置key信息'}>




            <Form form={update_private_key_modal_form} initialValues={update_private_key_modal_initialValues} onFinish={update_private_key_modal_onfinish}>

                <label>private_key</label>

                <Form.Item name={'input_value1'} rules={[{message:'必填项',required:true}]}>

                    <Input>



                    </Input>


                </Form.Item>



                <Button htmlType={'submit'} type={'primary'}>提交</Button>
                <Button style={{marginLeft:10}} onClick={setupdate_private_key_modal_oncancel}>取消</Button>

            </Form>


        </Modal>





    </div>)}

export default Admin_setting;
